import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AcceptTeamInvitationArgs {
  @Field(t => Int)
  teamId!: number

  @Field(t => Int, { nullable: true })
  userEmailId?: number
}
